import styled from "styled-components";
import { SkillsCard } from '../styles/MySkills.styled'
export const MainBody = styled.div`
    background-color: ${(props) => props.theme.colors.primary};
`
export const Container = styled.div`
    width: 90%;
    max-width: 1680px;
    margin: auto; 
    
`
export const PaddingContainer = styled.div`
    padding-top: ${({top}) => top};
    padding-bottom: ${({bottom}) => bottom};
    padding-left: ${({left}) => left};
    padding-right: ${({right}) => right};
    overflow: visible;

    @media(max-width: ${({theme}) => theme.breakpoints.mobile}){
        padding-top: ${({responsiveTop}) => responsiveTop};
        padding-bottom: ${({responsiveBottom}) => responsiveBottom};
        padding-left: ${({responsiveLeft}) => responsiveLeft};
        padding-right: ${({responsiveRight}) => responsiveRight};
    
    }
        @media(max-width: ${({theme}) => theme.breakpoints.tablet}){
        padding-left: ${({tabletLeft}) => tabletLeft};
        padding-right: ${({tabletRight}) => tabletRight};
        padding-top: ${({tabletTop}) => tabletTop};
        padding-bottom: ${({tabletBottom}) => tabletBottom};
    
    }

`
export const FlexContainer = styled.div`
    display: flex;
    justify-content: ${({justify}) => justify};
    align-items: ${({align}) => align};
    gap: ${({gap}) => gap};
    flex-direction: ${({direction}) => direction};

    & > div {
        flex: ${({fullWidthChild}) => fullWidthChild && 1};
    }

    @media(max-width: ${({theme}) => theme.breakpoints.tablet}){
        display: ${({responsiveFlex}) =>  responsiveFlex ? 'flex' : 'block'};

        flex-direction: ${({responsiveDirection}) => responsiveDirection};
    }
  

`
export const Heading = styled(PaddingContainer)`
    color: ${({theme}) => theme.colors.white};
    text-align: ${({align}) => align};
    font-size: ${({size}) => {
        switch(size){
            case 'h1':
                return '4.5rem';
            case 'h2':
                return '3rem';
            case 'h3':
                return '2rem';
            case 'h4':
                return '1.2rem';
            case 'h5':
                return '1rem';
            default:
                return; 
        }
    }};

    @media(max-width: ${({theme}) => theme.breakpoints.mobile}){
        font-size: ${({size}) => {
            switch(size){
                case 'h1':
                    return '2.5rem';
                case 'h2':
                    return '1.8rem';
                case 'h3':
                    return '1.4rem';
                case 'h4':
                    return '0.9rem';
                case 'h5':
                return '0.5rem';
                default:
                    return; 
            }
        }}
    }
`


export const BlueText = styled.span`
    color: ${({theme}) => theme.colors.secondary};

`
export const Text = styled.span`
        font-weight: ${({ weight }) => weight || "normal"};

`
export const ParaText = styled(PaddingContainer)`
    color: ${({theme}) => theme.colors.para_text_color};
    line-height: 2rem;

`
export const IconContainer = styled.div`
    font-size: ${({size}) => size};
    cursor: pointer;
    color: ${({color,theme}) => {
        switch(color){
            case 'white':
                return theme.colors.white;
            case 'blue':
                return theme.colors.secondary;
            default:
                return color;
        }
    }};
    ${SkillsCard} & {
        &:hover {
            transform: scale(1.2);
            transition: transform 0.3s ease-in-out;
        }
    }


`

export const Button = styled.div`
    display: inline-block;
    width: ${({ size }) => size || "max-content"};
    height: ${({ size }) => size || "max-content"};
    padding: 1rem 2rem;
    color: ${({theme}) => theme.colors.white};
    background-color: ${({theme}) => theme.colors.primary_light};
    border: 1px solid ${({theme}) => theme.colors.gray};
    border-radius: ${({ radius }) => radius || "5px"};
    cursor: pointer;
    transition: all 0.3s ease;
    &: hover{
        color: ${({theme}) => theme.colors.primary_light};
        background-color: ${({theme}) => theme.colors.white};
    }
`

export const FadeImage = styled.img`
    
    position: absolute; 
    top: ${({top}) => top}; 
    right: ${({right}) => right}; 
    left: ${({left}) => left}; 
    bottom: ${({bottom}) => bottom}; 
    user-select: none; 
    pointer-events: none; 
    max-width: 100%; 
    @media ${({theme}) => theme.breakpoints.mobile}{ 
        display: none;
    }
`

export const Picture = styled.img`
    
    top: ${({top}) => `calc(${top} + 20px)`};
    right: ${({right}) => right};
    left: ${({left}) => left};
    bottom: ${({bottom}) => bottom};
    
    max-width: 450px;
    width: 100%;
    max-height: 350px; /* Permite que la altura se ajuste dinámicamente */
    height: 100%;
    border: 3px solid transparent;
    border-image: linear-gradient(to right, rgb(131, 24, 0), #007bff) 1;

     @media ${({ theme }) => theme.breakpoints.mobile} {
        width: 90vw !important;
        height: 80vw;
        height: auto;
        margin: 0 auto; 
        display: block; 
  }

`
export const Image = styled.img`
    
    top: ${({top}) => top};
    right: ${({right}) => right};
    left: ${({left}) => left};
    bottom: ${({bottom}) => bottom};
    z-index: 0;
    width: 100px;
    height: 100px;

    border: 3px solid transparent;
    @media ${({theme}) => theme.breakpoints.mobile}{
        display: none;
        
    }
`
export const StyledDivider = styled.div`
  width: 100%;
  height: 2px; /* Grosor de la línea */
   min-height: 2px;
  background-color: white; /* Color de la línea */
  margin: 40px 0; /* Espaciado arriba y abajo */
`;
export const ImageSlider = styled.div`
  
   display: flex;
   align-items: center;
   justify-content: center;
   width: 100%;
   max-width: 100vw;
   min-height: 500px;
   min-width: 800px;
   overflow: visible;
`;

export const SliderContainer = styled.div`
  width: 100%;
  min-height: 300px; /* Asegura un tamaño mínimo para el slider */
  overflow: hidden;
`;

